import React from 'react'
import { useParams } from 'react-router-dom'
import {
    ItemCardTargetInfo,
    LogoImageForCardInfo,
    MainTargetInfo,
    NumberCalculatorsTargetInfo,
    NumberGridTargetInfo,
    TitleTargetInfo
} from '../../../../../../components/card/MainTargetInfo'
import { useSelector } from 'react-redux'
import MoneyImage from '../../../../../../assets/money.webp'

const formatNumber = (value) => {
    const n = Number(value || 0)
    return n.toLocaleString('es-BO', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })
}

const CardInfoEfectivoCierre = ({ reload, data, setData, nameLabel, efectivoParams }) => {
    const params = useParams()
    const reloadSubTable = useSelector(state => state.login.reloadSubTable)

    const efectivoId =
        efectivoParams?.type === 'subEfectivo'
            ? params.sub_efectivo_id
            : params.efectivo_id

    const includeChildren =
        efectivoParams?.type === 'subEfectivo'
            ? 'false'
            : 'true'

    const dataFormatted = data
        ? {
            ...data,
            monto_total_string: formatNumber(data?.monto_total),
            ingresos_total_string: formatNumber(data?.ingresos_total),
            egresos_total_string: formatNumber(data?.egresos_total),
            billetes_total_string: formatNumber(data?.billetes_total),
            monedas_total_string: formatNumber(data?.monedas_total),
            dolares_total_string: formatNumber(data?.dolares_total),
            dolares_en_bs_total_string: formatNumber(data?.dolares_en_bs_total),
        }
        : null

    return (
        <MainTargetInfo
            extraClassName='grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-1'
            urlApi={`/efectivo/${efectivoId}/resumen-cierres?includeChildren=${includeChildren}`}
            setData={setData}
            dataRef={[params.efectivo_id, params.sub_efectivo_id, reloadSubTable]}
            reload={reload}
        >
            <ItemCardTargetInfo
                logo={<LogoImageForCardInfo logo={MoneyImage} />}
                aditionalClassName='col-span-2 lg:col-span-1'
            >
                <TitleTargetInfo label={null} data={nameLabel} />
                <TitleTargetInfo
                    label={null}
                    data={dataFormatted?.efectivo_nombre || 'CAJA'}
                />
            </ItemCardTargetInfo>

            <NumberCalculatorsTargetInfo>
                <NumberGridTargetInfo label='Monto total Bs.' data={dataFormatted?.monto_total_string} />
                <NumberGridTargetInfo label='Ingresos Bs.' data={dataFormatted?.ingresos_total_string} />
                <NumberGridTargetInfo label='Egresos Bs.' data={dataFormatted?.egresos_total_string} />
                <NumberGridTargetInfo label='' data='' />
            </NumberCalculatorsTargetInfo>

            <NumberCalculatorsTargetInfo>
                <NumberGridTargetInfo label='Billetes Bs.' data={dataFormatted?.billetes_total_string} />
                <NumberGridTargetInfo label='Monedas Bs.' data={dataFormatted?.monedas_total_string} />
                <NumberGridTargetInfo label='Dolares Sus.' data={dataFormatted?.dolares_total_string} />
                <NumberGridTargetInfo label='Dolares Bs.' data={dataFormatted?.dolares_en_bs_total_string} />
            </NumberCalculatorsTargetInfo>
        </MainTargetInfo>
    )
}

export default CardInfoEfectivoCierre